import styled from '@emotion/styled';
import tw from 'twin.macro';

export const ErrorText = styled.p`
  ${tw`text-sm text-pink italic`}
`;

export default ErrorText;
